const PAYS_TAXES_OUTSIDE_COUNTRY = 'paysTaxesOutsideCountry';
const DOES_NOT_PAY_TAXES_OUTSIDE_COUNTRY = 'doesNotPayTaxesOutsideCountry';
const CRS_FIRST_NAME_ID = 'crsLegalFirstName';
const CRS_LAST_NAME_ID = 'crsLegalLastName';

// Actions for local reducer
const SET_TAX_STATUS = 'SET_TAX_STATUS';
const SET_TAX_DETAILS = 'SET_TAX_DETAILS';
const ADD_TAX_DETAILS = 'ADD_TAX_DETAILS';
const REMOVE_TAX_DETAILS = 'REMOVE_TAX_DETAILS';
const SET_LEGAL_FIRST_NAME = 'SET_LEGAL_FIRST_NAME';
const SET_LEGAL_LAST_NAME = 'SET_LEGAL_LAST_NAME';

const CPF_REGEX = /^[0-9]{11}$/;
const SSN_REGEX =
  /^(?!(000|666|9))[0-9]{3}(-?)(?!00)[0-9]{2}(-?)(?!0000)[0-9]{4}$/;
const PAN_REGEX = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;

const CRS_TAXPAYERID_OPTIONS = {
  NO_TAXPAYER_ID: 'NO_TAXPAYER_ID',
  SSN: 'SSN',
  TIN: 'TIN',
} as const;

const TAXID_US_SSN_MAXLEN = 9;
const TAXID_IN_PAN_MAXLEN = 10;
const TAXID_BR_CPF_MAXLEN = 11;

const NO_TAX_ID_REASON_ADD_EXPLANATION = 'addExplanation';

/* Key ordering matters for crsTaxDetailsChangeHandler */
/* eslint-disable sort-keys */
const CRS_TAX_DETAILS_FIELDS = {
  COUNTRY_CODE: 'countryCode',
  TAX_PAYER_ID_TYPE: 'taxPayerIdType',
  TAX_PAYER_ID_VALUE: 'taxPayerIdValue',
  NO_TAX_PAYER_ID_REASON: 'noTaxPayerIdReason',
  COMMENT: 'comment',
};

/* eslint-enable sort-keys */
type TaxPayerIdMapperType = {
  [key: string]: {
    [key: string]: {
      errorMessage: string;
      maxLength: number;
      regex: RegExp;
    };
  };
};

const TAX_PAYER_ID_MAPPER: TaxPayerIdMapperType = {
  BR: {
    TIN: {
      errorMessage: 'crs.errors.invalidTaxID.Brazil',
      maxLength: TAXID_BR_CPF_MAXLEN,
      regex: CPF_REGEX,
    },
  },
  IN: {
    TIN: {
      errorMessage: 'crs.errors.invalidTaxID.India',
      maxLength: TAXID_IN_PAN_MAXLEN,
      regex: PAN_REGEX,
    },
  },
  US: {
    SSN: {
      errorMessage: 'crs.errors.invalidTaxID.USA',
      maxLength: TAXID_US_SSN_MAXLEN,
      regex: SSN_REGEX,
    },
  },
};

const FPTI_VALUE_MISSING_ERROR = 'valueMissing';
const FPTI_INVALID_VALUE_ERROR = 'invalidValue';

export {
  ADD_TAX_DETAILS,
  CPF_REGEX,
  CRS_FIRST_NAME_ID,
  CRS_LAST_NAME_ID,
  CRS_TAX_DETAILS_FIELDS,
  CRS_TAXPAYERID_OPTIONS,
  DOES_NOT_PAY_TAXES_OUTSIDE_COUNTRY,
  FPTI_INVALID_VALUE_ERROR,
  FPTI_VALUE_MISSING_ERROR,
  NO_TAX_ID_REASON_ADD_EXPLANATION,
  PAN_REGEX,
  PAYS_TAXES_OUTSIDE_COUNTRY,
  REMOVE_TAX_DETAILS,
  SET_LEGAL_FIRST_NAME,
  SET_LEGAL_LAST_NAME,
  SET_TAX_DETAILS,
  SET_TAX_STATUS,
  SSN_REGEX,
  TAX_PAYER_ID_MAPPER,
  TAXID_BR_CPF_MAXLEN,
  TAXID_IN_PAN_MAXLEN,
  TAXID_US_SSN_MAXLEN,
};
